import { defineComponent as _defineComponent } from 'vue'

export enum OzDividerColorScheme {
  Solid = 'Solid',
  Translucent = 'Translucent',
  Popover = 'Popover',
}

export enum OzDividerOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

const __default__ = {}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzDivider',
  props: {
    darkMode: { type: [Boolean, String], default: 'auto' },
    colorScheme: null,
    orientation: { default: OzDividerOrientation.Horizontal },
    thickness: { default: 0.5 }
  },
  setup(__props: any) {



return { __sfc: true,OzDividerColorScheme, OzDividerOrientation }
}

})